module.exports = __webpack_public_path__ + "static/media/logo.29aaca34.svg";